import React from 'react';
import styled from 'styled-components';

const StyledA = styled.a`
  font-weight: 500;
  margin: 8px;
`;

const EnviarWhatsapp = ({ numero, mensaje }) => {
  const urlWhatsapp = `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`;

  return (
    <StyledA href={urlWhatsapp} target="_blank" rel="noopener noreferrer">
      916660482
    </StyledA>
  );
};

export default EnviarWhatsapp;